// to avoid others proxying our site and potential grabing passwords or switching our payment element for theirs we try to through a 404 in case the hostname does not match an expected pattern.
// todo: replace with vuepal config once we update to vuepal >= 3.0.0 https://liip.slack.com/archives/C36M5KQ9Z/p1745390006004139?thread_ts=1744795657.073949&cid=C36M5KQ9Z

export default defineNuxtPlugin(() => {
  const validHostnamePatterns = [
    /(\/|\.)oris.lndo.site$/,
    /(\/|\.)oris.ch$/,
    /\.platformsh\.site$/, // do not include our project id here to not leak our testing domains.
  ]

  const currentHostname = document.location.origin

  if (
    !validHostnamePatterns.some((validHostnamePattern) =>
      currentHostname.match(validHostnamePattern),
    )
  ) {
    throw createError({ statusCode: 404, fatal: true })
  }
})
